import { render, staticRenderFns } from "./SRVRecordForm.vue?vue&type=template&id=ab123046&"
import script from "./SRVRecordForm.vue?vue&type=script&lang=js&"
export * from "./SRVRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab123046')) {
      api.createRecord('ab123046', component.options)
    } else {
      api.reload('ab123046', component.options)
    }
    module.hot.accept("./SRVRecordForm.vue?vue&type=template&id=ab123046&", function () {
      api.rerender('ab123046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/Records/SRVRecordForm.vue"
export default component.exports